import { getValueToNullableCell } from 'helpers/stringHandler';

const PlcType = {
  SIEMENS_S7: 'SIEMENS_S7',
  ROCKWELL: 'ROCKWELL',
  IRIS_V3: 'IRIS_V3',
  IRIS_V3_ESSENTIALS: 'IRIS_V3_ESSENTIALS',
  IRIS_V3_INSIDE_S7: 'IRIS_V3_INSIDE_S7',
  IRIS_V3_INSIDE_ROCKWELL: 'IRIS_V3_INSIDE_ROCKWELL',
  UNKNOWN: 'UNKNOWN'
};

const PlcProtocols = [
  {
    value: PlcType.SIEMENS_S7,
    type: 'S7 Connection'
  },
  {
    value: PlcType.ROCKWELL,
    type: 'Rockwell'
  },
  {
    value: PlcType.IRIS_V3,
    type: 'IRIS V3 InView'
  },
  {
    value: PlcType.IRIS_V3_ESSENTIALS,
    type: 'IRIS V3 Essentials'
  },
  {
    value: PlcType.IRIS_V3_INSIDE_S7,
    type: 'IRIS V3 Inside S7'
  },
  {
    value: PlcType.IRIS_V3_INSIDE_ROCKWELL,
    type: 'IRIS V3 Inside Rockwell'
  }
];

const allPlcProtocols = [
  {
    value: PlcType.UNKNOWN,
    type: 'UNKNOWN'
  },
  ...PlcProtocols
];

const getPlcProtocolName = (value, withUnknown = true) => {
  const protocolList = withUnknown ? allPlcProtocols : PlcProtocols;
  const protocol = protocolList.find(item => item.value === value);
  return getValueToNullableCell(protocol?.type);
};

const PlcRacks = [
  { value: 0 },
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 4 },
  { value: 5 },
  { value: 6 },
  { value: 7 },
  { value: 8 },
  { value: 9 }
];

const PlcSlots = [
  { value: 0 },
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 4 },
  { value: 5 },
  { value: 6 },
  { value: 7 },
  { value: 8 },
  { value: 9 }
];

const IRIS_INSIDE_VARIANTS = [PlcType.IRIS_V3_INSIDE_S7, PlcType.IRIS_V3_INSIDE_ROCKWELL];
const IRIS_V3_VARIANTS = [PlcType.IRIS_V3].concat(IRIS_INSIDE_VARIANTS);

const isIrisV3Variant = plcType => IRIS_V3_VARIANTS.includes(plcType);
const isIrisInsideVariant = plcType => IRIS_INSIDE_VARIANTS.includes(plcType);


export {
  PlcType,
  PlcProtocols,
  PlcRacks,
  PlcSlots,
  getPlcProtocolName,
  isIrisV3Variant,
  isIrisInsideVariant,
  IRIS_V3_VARIANTS,
  IRIS_INSIDE_VARIANTS
};
